import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu as MenuIcon, X } from "lucide-react";
import { useCart } from "@/contexts/CartContext";
import { Button } from "@/components/ui/button";

const Header = () => {
  const { count } = useCart();
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const navClass = ({ isActive }) =>
    `text-sm font-medium tracking-wide transition-colors ${
      isActive ? "text-[#D90429]" : "text-neutral-700 hover:text-black"
    }`;

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 h-20 sm:h-24 md:h-28 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 sm:gap-3 min-w-0 flex-shrink" data-testid="logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_pho-express-lausanne/artifacts/gp5qekfl_logoquang1.png"
            alt="Chez Quang"
            className="h-14 sm:h-16 md:h-20 lg:h-24 w-auto object-contain max-w-full"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={navClass} data-testid="nav-home">Accueil</NavLink>
          <NavLink to="/commander" className={navClass} data-testid="nav-order">Commander</NavLink>
          <NavLink to="/mes-commandes" className={navClass} data-testid="nav-myorders">Mes commandes</NavLink>
        </nav>

        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <Link to="/commander" data-testid="header-cart-link">
            <Button
              variant="outline"
              className="relative border-neutral-300 hover:bg-neutral-100 rounded-md h-10 px-3 sm:px-4"
              data-testid="header-cart-button"
            >
              <ShoppingBag className="w-4 h-4 sm:mr-2" />
              <span className="hidden sm:inline">Panier</span>
              {count > 0 && (
                <span
                  data-testid="cart-count-badge"
                  className="absolute -top-2 -right-2 bg-[#D90429] text-white text-[11px] font-bold w-5 h-5 rounded-full flex items-center justify-center"
                >
                  {count}
                </span>
              )}
            </Button>
          </Link>
          <button
            className="md:hidden p-2 rounded-md hover:bg-neutral-100"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-5 h-5" /> : <MenuIcon className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-neutral-200 bg-white">
          <div className="px-5 py-4 flex flex-col gap-3">
            <NavLink to="/" end className={navClass} data-testid="mnav-home">Accueil</NavLink>
            <NavLink to="/commander" className={navClass} data-testid="mnav-order">Commander</NavLink>
            <NavLink to="/mes-commandes" className={navClass} data-testid="mnav-myorders">Mes commandes</NavLink>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
